import { useParams } from 'react-router-dom';
import { useDataLoaderNew } from 'data-loader';
import { MARKET_REQUESTS_UPDATED, MarketRequest, useMarketRequestsAdminService } from 'nekst-api';
import {
  LoadingAnimation,
  ShowContext,
  Text,
  TextField,
  useShowContextRequired,
  Cell,
  SimpleBlock
} from 'ui-builder';
import { ColumnLayout, PreviewFileWidget, WysiwygField } from 'features/nekst-widgets';
import React from 'react';
import RequestStatusField from '../../../markets/requests/RequestStatusField';
import UserField from './UserField';
import InnerBlock from '../../../../shared/web/layout/InnerBlock';
import { UpdateMarketRequestButton } from './UpdateRequestForm';
import MarketRequestsBreadcrumbs from './MarketRequestsBreadcrumbs';
import { Breadcrumb } from '../../../../shared/web/layout/Breadcrumbs';

function AttachedFiles() {
  const { data } = useShowContextRequired<MarketRequest>();

  if (data.attachedFiles.length > 0) {
    return (
      <>
        {data.attachedFiles.map((item) => (
          <SimpleBlock>
            <PreviewFileWidget file={item._file} key={item.title} />
          </SimpleBlock>
        ))}
      </>
    );
  } else {
    return <Text>No files attached</Text>;
  }
}

export function MarketRequestPage() {
  const marketRequestsAdminService = useMarketRequestsAdminService();

  const params = useParams();

  const id = parseInt(params.id!);

  const { data } = useDataLoaderNew(
    async () => marketRequestsAdminService.getMarketRequest(id),
    {
      events: [MARKET_REQUESTS_UPDATED]
    }
  );

  if (data) {
    return (
      <>
        <MarketRequestsBreadcrumbs>
          <Breadcrumb text={data.name} />
        </MarketRequestsBreadcrumbs>
        <ShowContext data={data}>
          <InnerBlock
            title={data.name}
            headerRight={<UpdateMarketRequestButton />}
          >
            <ColumnLayout>
              <TextField source="name" label="Name" />
              <Cell label="Author">
                <UserField />
              </Cell>
              <Cell label="Status">
                <RequestStatusField />
              </Cell>
              <WysiwygField source="description" label="Description" />
              <Cell label="Attached Files">
                <AttachedFiles />
              </Cell>
              <Cell label="Market Name">
                <TextField source="_setupArea.name" noDataMessage="-" />
              </Cell>
              <WysiwygField source="resultDescription" label="Response" noDataMessage="-" />
            </ColumnLayout>
          </InnerBlock>
        </ShowContext>
      </>
    );
  } else {
    return (
      <LoadingAnimation />
    );
  }
}
